import { forwardRef } from "react";
import RcCollapse, { Panel } from "rc-collapse";

const collapseMotion = {
	motionName: "rc-collapse-motion",
	onEnterStart: () => ({ height: 0 }),
	onEnterActive: node => ({ height: node.scrollHeight }),
	onLeavePrepare: () => Promise.resolve(),
	onLeaveStart: node => ({ height: node.offsetHeight }),
	onLeaveActive: () => ({ height: 0 }),
	motionDeadline: 500,
};

const Collapse = forwardRef((props, ref) => {
	return <RcCollapse ref={ref} openMotion={collapseMotion} {...props} />;
});

Collapse.displayName = "Collapse";
Collapse.Panel = Panel;

export { Panel };
export default Collapse;
